import { createContext } from 'react';
/** undefined retains standalone behavior; native entry supplies confirmed, account-scoped display only. */
export const PlayerPresentation = createContext<{ name: string; avatar: string } | undefined>(undefined);
